import * as React from 'react';
import styled from 'styled-components';

const DocumentalIconWrapper = styled.div`
  font-size: 18px;
  color: ${({ theme }) => theme.colorPrimaryBgHover};
`;

export interface IDocumentalIconProps
  extends React.HTMLAttributes<HTMLDivElement> {}

/**
 * Container impostare colore e dimensione icona.
 */
export function DocumentalIcon(props: IDocumentalIconProps) {
  return <DocumentalIconWrapper {...props} />;
}
